export default __webpack_public_path__ + "static/media/login.c7aaf4e4.svg";